// extracted by mini-css-extract-plugin
export default {"btns_action":"SubsystemPopupMenuVars_btns_action__esfs0"};